import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { usePatrolSteelVersionsApi } from "../../../../../http/patrol/useSteelVersion";
import CommonSteelVersion from "../../../globalSettings/steelVersions/CommonSteelVersion";
import { PATROL } from "../../AdminSystemSettings";

const PatrolSteelVersion: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { steelVersionId: steelVersionId } = useParams<{ steelVersionId: string }>();
  const supportMaterialsApi = usePatrolSteelVersionsApi();

  const aborter = useRef(new AbortController());
  const { error, data, trigger } = supportMaterialsApi.getAdminMaterial(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=3`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.steelVersions.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    steelVersionId && trigger(steelVersionId);
  }, [steelVersionId]);

  return (
    <CommonSteelVersion
      isGlobalSettings={false}
      data={data}
      error={error}
      trigger={() => steelVersionId && trigger(steelVersionId)}
      title={`${i18n.translation.steelVersions.singular}: ${data?.name ?? ""}`}
      steelVersionId={steelVersionId}
      path={path}
      updateSteelVersion={supportMaterialsApi.updateAdminMaterial}
    />
  );
};

export default PatrolSteelVersion;
